import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { useIntl } from 'gatsby-plugin-react-intl';

import RichText, { fragment } from '../../../Core/RichText';
import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import VideoTutorialTile from '../VideoTutorialTile';
import IndividualBlade from '../../IndividualBlades';

import { Wrapper, GridContainer, CtaWrapper } from './styles';

const VideoPopularSection = ({ data = null }) => {
  if (!data) return null;
  const intl = useIntl();
  const defaultVideos = useStaticQuery(query);
  const {
    allContentfulVideoTutorialPage: { nodes: defaultVideoItems },
  } = defaultVideos;
  const { sectionContainerHeading, sectionSubheading, elements, ctas } = data;
  let items = elements;

  if (items.length === 0) {
    items = defaultVideoItems.filter(
      ({ node_locale }) => node_locale === `${intl.locale}-CA`,
    );
  }

  return (
    <Container className="learning-hub">
      <Wrapper>
        <RichText document={sectionContainerHeading} />
        <RichText document={sectionSubheading} />
      </Wrapper>
      <GridContainer>
        {elements
          .map(
            ({
              id,
              updatedAt,
              pageSlug,
              sections: videoTutorialSections,
              videoTutorialProductCategories,
              videoTutorialCategories,
              frenchVideoTutorialProductCategories,
              frenchVideoTutorialCategories,
            }) => {
              const video = videoTutorialSections.find(
                ({ __typename }) => __typename === 'ContentfulVideoItem',
              );
              if (!video) return null;
              return (
                <VideoTutorialTile
                  key={id}
                  url={`/learning-hub/video-tutorials/${pageSlug}`}
                  title={video.videoLabel}
                  description={video.videoDescription}
                  thumbnail={video.thumbnailDam}
                  duration={video.videoDuration}
                  contentType={videoTutorialCategories}
                  productType={videoTutorialProductCategories}
                  contentTypeFR={frenchVideoTutorialCategories}
                  productTypeFR={frenchVideoTutorialProductCategories}
                  updatedAt={updatedAt}
                />
              );
            },
          )
          .filter(video => !!video)}
      </GridContainer>
      {ctas && (
        <CtaWrapper>
          {ctas &&
            ctas.map(cta => {
              if (cta.hideFrench === true) return null;
              return cta.internal.type === 'ContentfulBlade' ? (
                <IndividualBlade key={cta.id} data={cta} />
              ) : (
                <Link key={cta.id} data={cta}>
                  <RichText document={cta.label} options={fragment} />
                </Link>
              );
            })}
        </CtaWrapper>
      )}
    </Container>
  );
};

VideoPopularSection.propTypes = {
  data: PropTypes.shape(),
};

export default VideoPopularSection;

// We fetch the top 8 because english and french share the same view counts being the same item
// And static query does not allow use to filter by languages through interpolation
const query = graphql`
  query VideoPopularSection {
    allContentfulVideoTutorialPage(sort: { viewCount: DESC }, limit: 8) {
      nodes {
        viewCount
        title
        id
        node_locale
        pageSlug
        pageTitle
        metaDescription
        languageToggle
        displayInSiteMap
        videoTutorialProductCategories
        videoTutorialCategories
        frenchVideoTutorialProductCategories
        frenchVideoTutorialCategories
        sections {
          ...video_item
        }
      }
    }
  }
`;
